import { createContext } from 'react';
export const RouteContext = createContext({
    routes: [],
});
//# sourceMappingURL=RouteContext.js.map